import { LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpaceDualAxisChartWidgetOptions } from './types';

export class HyperSpaceDualAxisChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceDualAxisChartWidgetOptions {
    @observable baseXYChartOptions: HyperSpaceDualAxisChartWidgetOptions['baseXYChartOptions'] = {
        grid: {
            enabled: false,
        },
        yAxes: [
            {
                type: 'line',
            },
            {
                type: 'column',
            },
        ],
        dataLabels: {
            enabled: false,
            fontSize: 30,
            formats: {
                numberFormat: {
                    decimals: 0,
                    useShortened: true,
                },
                dateFormat: {
                    autoFormat: true,
                    formatString: 'dd MMM',
                },
            },
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: HyperSpaceDualAxisChartWidgetOptions['metaInfoOptions'] = {
        color: {
            enabled: false,
            type: 'fill',
        },
    };
}
